import { getRentDate } from "./formatTime";

const getRentState = (room) => {
  if (!room) {
    return "無房間";
  }
  return room.renters ? "已出租" : "未出租";
};

const addSearchedField = (rooms) => {
  rooms.forEach((room) => {
    if (room.searchedField) {
      return; // already contained
    }

    const { renters, cost } = room;

    const names = renters ? renters.map((renter) => renter.name).join(",") : "";

    const searchedTexts = [
      getRentState(room),
      renters ? renters[0]?.memberNumber : "", // take the first renter
      names,
      renters ? renters[0]?.phoneNumber : "",
      String(cost),
      getRentDate(room.rentStartDate, room.rentEndDate),
    ];

    room.searchedField = searchedTexts.join(" ");
  });
};
export { addSearchedField, getRentState };
